const ANDROID_PLAY_STORE_PACKAGE = "com.heycoach.heycoach";
const IOS_APP_STORE_BUNDLE = "com.heycoachai.heycoach";
const IOS_APP_STORE_ID = "6777252797";

export function getIosAppStoreBundle() {
  return IOS_APP_STORE_BUNDLE;
}

export function getIosAppStoreUrl() {
  return `https://apps.apple.com/ca/app/hey-coach/id${IOS_APP_STORE_ID}`;
}

export function getAndroidPlayStoreUrl() {
  return `https://play.google.com/store/apps/details?id=${encodeURIComponent(ANDROID_PLAY_STORE_PACKAGE)}`;
}
